/* Product card: finish dots swap the card image and link to that variant. */
(() => {
  if (window.__ntCard) return; window.__ntCard = true;
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.nt-card__dot');
    if (!dot) return;
    const card = dot.closest('[data-nt-card]');
    card.querySelectorAll('.nt-card__dot').forEach((d) => d.classList.toggle('is-active', d === dot));
    const img = card.querySelector('[data-nt-card-img]');
    if (img && dot.dataset.img) { img.srcset = dot.dataset.srcset || ''; img.src = dot.dataset.img; }
    const fin = card.querySelector('[data-nt-card-finish]'); if (fin) fin.textContent = dot.dataset.name;
    card.querySelectorAll('a[href]:not([data-nt-card-chip])').forEach((a) => { if (dot.dataset.url) a.href = dot.dataset.url; });
  });
})();
